import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEraser16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconEraser16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m8.92 3.536 1.39 1.39-4.165 4.163L4.755 7.7zm-2.068 6.26 4.165-4.164 1.39 1.39-4.165 4.164zM4.05 8.408l-.678.678a1 1 0 0 0 0 1.414l2.072 2.072a1 1 0 0 0 1.414 0l.678-.678zm4.87-6.286.707.707 3.486 3.486.707.707-.707.707-5.549 5.549a2 2 0 0 1-2.828 0l-2.072-2.072a2 2 0 0 1 0-2.828l5.549-5.55zM10 13a.5.5 0 1 0 0 1h3.5a.5.5 0 1 0 0-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEraser16);
